import React from 'react';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { StyledCenteredDiv } from '@styles/generalStyles';
import { ReactFCV } from '@types';

import { StyledBar, StyledCircle, StyledMobileTitle } from './styled';

export const PagesStepChainSkeleton: ReactFCV<IBasicStyledProps> = (rest) => (
  <div {...rest}>
    <StyledCenteredDiv>
      <StyledCircle data-testid="circle" height={2} width={2} />
      <StyledBar data-testid="bar" />
      <StyledCircle data-testid="circle" height={2} width={2} />
      <StyledBar data-testid="bar" />
      <StyledCircle data-testid="circle" height={2} width={2} />
      <StyledBar data-testid="bar" />
      <StyledCircle data-testid="circle" height={2} width={2} />
    </StyledCenteredDiv>
    <StyledCenteredDiv>
      <StyledMobileTitle data-testid="mobile-title" height={1} width={7.5} />
    </StyledCenteredDiv>
  </div>
);
